import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    allPSshots,
    select_PSshottype,
    editPracticeDrill,
 } from 'Actions';

class EditItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        this.props.allPSshots();
	}
    constructor(props) {
      
        super(props);
        this.state = {
            lsttype:this.props.data.lsttype, 
            selshot:this.props.data.selshot, 
            seltype:this.props.data.seltype, 
            seldrill:this.props.data.seldrill, 
            eid:this.props.data.eid, 
        };
    }



    selshot(event){

        var shotid=event.target.value;        
        this.setState({ 
            selshot:shotid,
            seltype:''
        });
        this.props.select_PSshottype(shotid).then((data) => {   

            if(data.status==1){
                var resdata=data.data;
                this.setState({ 
                    lsttype:resdata
                });
                
            }
        });

    }

    seltype(event){

        var typeid=event.target.value;        
        this.setState({ 
            seltype:typeid
        });
        
    }
    

    editHandleSubmit(event){
        event.preventDefault();
        var id=this.state.eid;
        this.props.editPracticeDrill(event, id).then((data) => {   
        
            
        });
        
    }  


render() {

    const { allshotlist, particulardrilll, loading} = this.props;
     
      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="editform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8">
                            <RctCollapsibleCard heading="Edit Drill">   
                                <div className="row float-right"> 
                                        <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                 </div>  
                                    <div className="row">                                 
                                       
                                        <div className="col-sm-12 col-md-7">
                                          <FormGroup>
                                             <Label for="Select">Shot *</Label>
                                             <select name="drillshot" id="drillshot" className="form-control form-control-alternative" value={this.state.selshot} onChange={evt => this.selshot(evt)} required>
                                                <option value=""> </option>
                                                {allshotlist.map((shotval) => ( 
                                                <option value={shotval.gpsID}>{shotval.gps_shot}</option>                                                    
                                                ))}  
                                             </select>
                                             
                                          </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-md-7">
                                          <FormGroup>
                                             <Label for="Select">Type *</Label>
                                             <select name="drilltype" id="drilltype" className= "form-control form-control-alternative" value={this.state.seltype} onChange={evt => this.seltype(evt)} required>
                                                <option value=""> </option>
                                                {this.state.lsttype.map((optval) => ( 
                                                    <option value={optval.gpd_sheadID}>{optval.gpsh_name}</option>                                                           
                                                ))}                                           
                                             </select>
                                          </FormGroup>
                                       </div>
                                       <div className="col-md-12">
                                            <FormGroup>
                                                <Label for="Select">Drill *</Label>
                                                <textarea rows="3" type="text" name="desc" id="desc" className="form-control form-control-alternative" defaultValue={this.state.seldrill} required></textarea>
                                            </FormGroup>
                                       </div>
                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />     
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ practiceschedule, practicedrill}) => {
    const { allshotlist, loading } = practiceschedule;
    const { particulardrilll } = practicedrill;
    return { allshotlist, particulardrilll, loading };
   
}


export default connect(mapStateToProps, {
    allPSshots,
    select_PSshottype,
    editPracticeDrill,
})(EditItems);
